import HookBuilderQuery from '@/hooks/HookBuilderQuery';
import { UnitService } from '@/services/units';

export const useUnits = HookBuilderQuery.regularHook(['units'], UnitService.search, {
  errorMessage: 'There was an error while loading the units',
});

export const useUnit = HookBuilderQuery.regularHook(['unit'], UnitService.getById, {
  errorMessage: 'There was an error while loading the unit',
});

export const useNearbySchools = HookBuilderQuery.regularHook(
  ['unit-nearby-schools'],
  UnitService.getNearbySchools,
  {
    errorMessage: 'There was an error while loading the nearby schools',
  },
);
